module.exports = __webpack_public_path__ + "static/media/E. Scott Santi@2x.59ddb023.jpg";